import * as React from "react";
import { Grid, GridColumn, Input } from "semantic-ui-react";
import "./project-new.css";
import MyDatePicker from "../../../components/date-picker/date-picker";
import LabeledInput from "../../../components/labeled-input/labeled-input";
import LabeledTextArea from "../../../components/labeled-textarea/labeled-textarea";
import { Contact } from "../../../stores/contact/contact-store";
import { KeyValueStore } from "../../../stores/key-value/key-value-store";
import { Municipality } from "../../../stores/municipality/municipality-store";
import { getDesc, getLabel } from "../../../reflection/reflection";
import { LandfillSiteProject, SoilImprovementProject } from "../../../stores/project/project";

export default function SoilImprovementNew({
                                               municipalities,
                                               contacts,
                                               keyValueStore
                                           }: {
    municipalities: Municipality[];
    contacts: Contact[];
    keyValueStore: KeyValueStore
}): JSX.Element {
    return (
        <div>
            <Grid columns={2} relaxed={true} stackable={true}>
                <GridColumn largeScreen={16} widescreen={8}>
                    <LabeledInput
                        label="Name"
                        inputElement={<Input type="text" name="name" maxLength={50}/>}
                        required={true}
                    />
                    <LabeledInput
                        label={getLabel(SoilImprovementProject.prototype, "municipalityName")}
                        desc={getDesc(SoilImprovementProject.prototype, "municipalityName")}
                        inputElement={
                            <select name="municipality" className="ui selection dropdown">
                                <option disabled selected>
                                    -- Auswählen --
                                </option>
                                {municipalities.map((m) => (
                                    <option
                                        key={m.bfsNr}
                                        value={m.bfsNr}
                                    >
                                        {m.name}
                                    </option>
                                ))}
                            </select>
                        }
                        required={true}
                    />
                    <LabeledInput
                        label={getLabel(SoilImprovementProject.prototype, "place")}
                        desc={getDesc(SoilImprovementProject.prototype, "place")}
                        inputElement={<Input type="text" name="place"/>}
                        required={true}
                    />
                    <LabeledInput
                        label={getLabel(SoilImprovementProject.prototype, "status")}
                        desc={getDesc(SoilImprovementProject.prototype, "status")}
                        inputElement={
                            <select name="status" className="ui selection dropdown">
                                <option disabled selected>
                                    -- Auswählen --
                                </option>
                                {keyValueStore.projectStatuses.map((s) => (
                                    <option
                                        key={s.key}
                                        value={s.key}
                                    >
                                        {s.value}
                                    </option>
                                ))}
                            </select>
                        }
                        required={true}
                    />
                    <LabeledInput
                        label={getLabel(SoilImprovementProject.prototype, "ebageNr")}
                        desc={getDesc(SoilImprovementProject.prototype, "ebageNr")}
                        inputElement={<Input type="text" name="ebageNr"/>}
                        required={true}
                    />
                    <LabeledInput
                        label={getLabel(SoilImprovementProject.prototype, "enactmentDateDisplayText")}
                        desc={getDesc(SoilImprovementProject.prototype, "enactmentDateDisplayText")}
                        inputElement={<MyDatePicker name="enactmentDate"/>}
                    />
                    <LabeledInput
                        label={getLabel(SoilImprovementProject.prototype, "approvedCreationArea")}
                        desc={getDesc(SoilImprovementProject.prototype, "approvedCreationArea")}
                        inputElement={<Input name="approvedCreationArea" type="number"/>}
                    />
                    <LabeledInput
                        label={getLabel(SoilImprovementProject.prototype, "creationGoalSource")}
                        inputElement={
                            <select name="creationGoalSource" className="ui selection dropdown">
                                <option key={-1} value="" selected>
                                    -- Auswählen --
                                </option>
                                {keyValueStore.creationGoalSources.map((e) => (
                                    <option
                                        key={e.key}
                                        value={e.key}
                                    >
                                        {e.value}
                                    </option>
                                ))}
                            </select>
                        }
                    />
                    <LabeledInput
                        label={getLabel(SoilImprovementProject.prototype, "landOwnerFullName")}
                        desc={getDesc(SoilImprovementProject.prototype, "landOwnerFullName")}
                        inputElement={
                            <select name="landOwnerId" className="ui selection dropdown">
                                <option key={-1} value="" selected>
                                    -- Auswählen --
                                </option>
                                {contacts.map(c => (
                                    <option
                                        key={c.id}
                                        value={c.id}
                                    >{`${c.firstName} ${c.lastName}`}</option>
                                ))}
                            </select>
                        }
                    />
                    <LabeledInput
                        label={getLabel(SoilImprovementProject.prototype, "cmiNumberRawi")}
                        desc={getDesc(SoilImprovementProject.prototype, "cmiNumberRawi")}
                        inputElement={<Input type="text" name="cmiNrRawi"/>}
                    />
                    <LabeledInput
                        label={getLabel(SoilImprovementProject.prototype, "constructionSupervisorFullName")}
                        desc={getDesc(SoilImprovementProject.prototype, "constructionSupervisorFullName")}
                        inputElement={
                            <select name="constructionSupervisorId" className="ui selection dropdown">
                                <option key={-1} value="" selected>
                                    -- Auswählen --
                                </option>
                                {contacts.map(c => (
                                    <option
                                        key={c.id}
                                        value={c.id}
                                    >{`${c.firstName} ${c.lastName}`}</option>
                                ))}
                            </select>
                        }
                    />
                    <LabeledInput
                        label={getLabel(SoilImprovementProject.prototype, "requirementsSpecificationBBBStatus")}
                        desc={getDesc(SoilImprovementProject.prototype, "requirementsSpecificationBBBStatus")}
                        inputElement={
                            <select name="requirementsSpecificationBBBStatus" className="ui selection dropdown">
                                <option key={-1} value="" selected>
                                    -- Auswählen --
                                </option>
                                {keyValueStore.conditionControlStatuses.map(e => (
                                    <option key={e.key} value={e.key}>
                                        {e.value}
                                    </option>
                                ))}
                            </select>
                        }
                    />
                </GridColumn>
                <GridColumn>
                    <LabeledInput
                        label={getLabel(SoilImprovementProject.prototype, "requirementsSpecificationRequestSource")}
                        desc={getDesc(SoilImprovementProject.prototype, "requirementsSpecificationRequestSource")}
                        inputElement={
                            <select name="requirementsSpecificationRequestSource" className="ui selection dropdown">
                                <option key={-1} value="" selected> -- Auswählen --
                                </option>
                                {keyValueStore.conditionControlSources.map(e => (
                                    <option key={e.key} value={e.key}>
                                        {e.value}
                                    </option>
                                ))}
                            </select>
                        }
                    />
                    <LabeledInput
                        label={getLabel(SoilImprovementProject.prototype, "startConstructionMeetingStatus")}
                        desc={getDesc(SoilImprovementProject.prototype, "startConstructionMeetingStatus")}
                        inputElement={
                            <select name="startConstructionMeetingStatus" className="ui selection dropdown">
                                <option key={-1} value="" selected>
                                    -- Auswählen --
                                </option>
                                {keyValueStore.conditionControlStatuses.map(e => (
                                    <option key={e.key} value={e.key}>
                                        {e.value}
                                    </option>
                                ))}
                            </select>
                        }
                    />
                    <LabeledInput
                        label={getLabel(SoilImprovementProject.prototype, "startConstructionMeetingSource")}
                        desc={getDesc(SoilImprovementProject.prototype, "startConstructionMeetingSource")}
                        inputElement={
                            <select name="startConstructionMeetingSource" className="ui selection dropdown">
                                <option key={-1} value="" selected>
                                    -- Auswählen --
                                </option>
                                {keyValueStore.conditionControlSources.map(e => (
                                    <option key={e.key} value={e.key}>
                                        {e.value}
                                    </option>
                                ))}
                            </select>
                        }
                    />
                    <LabeledInput
                        label={getLabel(LandfillSiteProject.prototype, "geometrySource")}
                        desc={getDesc(LandfillSiteProject.prototype, "geometrySource")}
                        inputElement={<Input type="text" maxLength={50} name="geometrySource"/>}
                    />
                    <LabeledInput
                        label={getLabel(LandfillSiteProject.prototype, "geometrySourceDateDisplayText")}
                        desc={getDesc(LandfillSiteProject.prototype, "geometrySourceDateDisplayText")}
                        inputElement={<MyDatePicker name="geometrySourceDate"/>}
                    />
                    <LabeledTextArea label={getLabel(SoilImprovementProject.prototype, "generalRemarks")}
                                     name="generalRemarks"/>
                    <LabeledTextArea label={getLabel(SoilImprovementProject.prototype, "enactmentRemarks")}
                                     name="enactmentRemarks"/>
                    <LabeledTextArea label={getLabel(SoilImprovementProject.prototype, "creationGoalRemarks")}
                                     name="creationGoalRemarks"/>
                </GridColumn>
            </Grid>
        </div>
    );
}
